import React from 'react'
import styled from 'styled-components'
import Plaatjie from '@ubo/plaatjie'
import ParseContent from '../shared/ParseContent'
import ButtonLanding from './ButtonLanding'

const Section = styled.section`
  @media (min-width: 992px) {
    margin-top: 0;
    margin-bottom: 5rem;
  }

  @media (max-width: 991.98px) {
    margin-block: 3rem;
  }
`

const Band = styled.div`
  position: relative;
  background-color: #d50021;
  color: #fff;

  /* The red band runs off the left edge of the viewport. */
  &::before {
    position: absolute;
    content: '';
    top: 0;
    right: 100%;
    height: 100%;
    width: 2000px;
    background-color: #d50021;
  }

  @media (min-width: 992px) {
    min-height: 277px;
    padding: 42px 100px 42px 38px;
  }

  @media (max-width: 991.98px) {
    padding: 2rem 1.5rem;
  }
`

const Description = styled.div`
  & p {
    font-weight: 600;
    margin-bottom: 0;
  }

  @media (min-width: 992px) {
    & p {
      font-size: 20px;
      line-height: 30px;
    }
  }

  @media (max-width: 991.98px) {
    & p {
      font-size: 16px;
      line-height: 25px;
    }
  }
`

const CtaButton = styled(ButtonLanding)`
  margin-top: 23px;

  @media (min-width: 992px) {
    & > a,
    & > button {
      width: 276px;
      min-height: 71px;
      padding-inline: 36px;
    }
  }
`

const ImageWrapper = styled.div`
  position: relative;
  z-index: 2;
  padding: 3px;
  clip-path: polygon(
    0 0,
    100% 0,
    100% calc(100% - 40px),
    calc(100% - 40px) 100%,
    0 100%
  );

  & > div {
    clip-path: polygon(
      0 0,
      100% 0,
      100% calc(100% - 38px),
      calc(100% - 38px) 100%,
      0 100%
    );
  }

  @media (min-width: 992px) {
    width: 257px;
    margin-left: -3rem;
    margin-top: 46px;
  }

  @media (max-width: 991.98px) {
    max-width: 257px;
    margin: 2rem auto 0;
  }
`

function CtaLanding({ cta }) {
  return (
    <Section>
      <div className="container">
        <div className="row align-items-start">
          <div className="col-lg-8 pr-lg-0">
            <Band>
              {cta.description && (
                <Description>
                  <ParseContent content={cta.description} />
                </Description>
              )}

              {cta.link && (
                <CtaButton
                  to={cta.link.url}
                  target={cta.link.target}
                  variant="dark"
                  notch={20}
                >
                  {cta.link.title}
                </CtaButton>
              )}
            </Band>
          </div>

          <div className="col-lg-4 d-flex">
            <ImageWrapper>
              <Plaatjie image={cta.image} alt="" />
            </ImageWrapper>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default CtaLanding
